import type { Entitlement, PlanId } from './types';

export interface Plan {
  id: PlanId; name: string; price: number; per: string; billing: string; days?: number; for: string; features: string[];
}

/* Keep prices in step with functions/src/config.ts — the server decides what is charged. */
export const PLANS: Record<PlanId, Plan> = {
  single: { id: 'single', name: 'Single website', price: 8000, per: 'one-time', billing: 'One-time payment', for: 'For your own wedding', features: ['Publish one wedding website', 'Keep editing after it’s live', 'RSVP form and reply downloads', 'Every design and block'] },
  monthly: { id: 'monthly', name: 'Monthly', price: 40000, per: 'per month', billing: 'Billed every month', days: 30, for: 'For planners with several weddings', features: ['Publish as many websites as you like', 'Edit and republish any time', 'RSVP replies for every website', 'Billed every month'] },
  yearly: { id: 'yearly', name: 'Yearly', price: 480000, per: 'per year', billing: 'Billed once a year', days: 365, for: 'For planners booked all year', features: ['Publish as many websites as you like', 'Edit and republish any time', 'RSVP replies for every website', 'Billed once a year'] },
};
export const PLAN_ORDER: PlanId[] = ['single', 'monthly', 'yearly'];

export const EMPTY_ENTITLEMENT: Entitlement = { sub: null, sites: {} };

export const subActive = (e: Entitlement | null | undefined, now = Date.now()) => !!(e && e.sub && e.sub.end > now);
export const sitePaid = (e: Entitlement | null | undefined, siteId: string) => !!(e && e.sites && e.sites[siteId]);
export const canPublish = (e: Entitlement | null | undefined, siteId: string) => subActive(e) || sitePaid(e, siteId);

/* ---------- web addresses ---------- */
export const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{1,38})[a-z0-9]$/;
/** Addresses that would clash with the app's own pages. Mirrored in functions/src/config.ts. */
export const RESERVED_SLUGS = new Set([
  'login', 'signup', 'sign-up', 'logout', 'dashboard', 'edit', 'auth', 'forgot', 'reset', 'api', 'app', 'admin',
  'account', 'billing', 'pricing', 'plans', 'help', 'support', 'about', 'terms', 'privacy', 'assets', 'static',
  'www', 'kovio', 'w', 'u', 'site', 'sites', 'new', 'settings', 'favicon-ico', 'robots-txt', 'index',
]);

export function slugProblem(slug: string): string | null {
  if (!SLUG_RE.test(slug) || slug.includes('--')) return 'Use 3 to 40 lowercase letters, numbers or single hyphens, starting and ending with a letter or number.';
  if (RESERVED_SLUGS.has(slug)) return 'That address is reserved. Try a different one.';
  return null;
}
